import axios from 'axios'
import { PROVINCE, CITY, DISTRICT, ZIPCODE } from "../constants/api";

export function getProvinces() {
    return axios.get(PROVINCE);
}

export function getCities({provinceId}) {
    return axios.get(CITY(provinceId));
}

export function getDistricts({cityId}) {
    return axios.get(DISTRICT(cityId));
}

export function getZipcodes({cityId, districtId}) {
    return axios.get(ZIPCODE(cityId, districtId));
}